import Vue from "vue";


var xx = {};

function navigateToUrl(url, newwindow = true, is_unescape = true) {
  if (is_unescape) {
    url = unescape(url);
  }
  var f = document.createElement("FORM");
  f.action = url;
  if (newwindow) {
    f.target = '_blank';
  }
  var indexQM = url.indexOf("?");
  if (indexQM >= 0) {
    // the URL has parameters => convert them to hidden form inputs
    var params = url.substring(indexQM + 1).split("&");
    for (var i = 0; i < params.length; i++) {
      var keyValuePair = params[i].split("=");
      var input = document.createElement("INPUT");
      input.type = "hidden";
      input.name = keyValuePair[0];
      input.value = keyValuePair[1];
      f.appendChild(input);
    }
  }
  document.body.appendChild(f);
  f.submit();
}


var getUrlVars = function (url) {
  var vars = [],
    hash;
  url = url || window.location.href
  var hashes = url.slice(url.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars[hash[0]] = hash[1];
  }
  return vars;
};

function toThousands(num) {
  var num = (num || 0).toString(), result = '';
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return result;
}


var updateQueryStringParameter = function updateQueryStringParameter(uri, key, value) {
  if (!value) {
    return uri;
  }
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return uri + separator + key + "=" + value;
  }
}

function getDateDiff(dateTimeStamp) {
  var result = '';
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var halfamonth = day * 15;
  var month = day * 30;
  var now = new Date().getTime();
  var diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    return;
  }
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  if (monthC >= 1) {
    result = "" + parseInt(monthC) + "月前";
  } else if (weekC >= 1) {
    result = "" + parseInt(weekC) + "周前";
  } else if (dayC >= 1) {
    result = "" + parseInt(dayC) + "天前";
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + "小时前";
  } else if (minC >= 1) {
    result = "" + parseInt(minC) + "分钟前";
  } else
    result = "刚刚";
  return result;
}

function getdate(timestamp, add_time = false) {
  timestamp = parseInt(timestamp);
  var now = new Date(timestamp),
    y = now.getFullYear(),
    m = now.getMonth() + 1,
    d = now.getDate();
  var s = y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
  if (add_time) {
    s = s + " " + now.toTimeString().substr(0, 8);
  }
  return s
}


var showDate = function (timestamp) {
  var dtime = xx.init_data.now_time - timestamp;
  if (dtime > 60 * 60 * 24 * 7) {
    return xx.getdate(timestamp * 1000);
  }
  return xx.getDateDiff(timestamp * 1000)
}

var generate_avatar_url = function (userdata) {
  if (userdata.updated_avatar) {
    var nid = userdata.updated_avatar['nid'];
    console.log("image_hosts_conf:", this.image_hosts_conf)
    var host = this.image_hosts_conf[nid]['host'];
    return "https://" + host + "/avatar/" + userdata.uid;
  }
  return this.config.defalut_avatar;
}

var generate_cover_url = function (nid, id, hash_id) {
  if (nid) {
    var host = this.image_hosts_conf[nid]['host'];
    return "https://" + host + "/comic/" + id + "/" + hash_id;
  }
}


var generate_compic_url = function (nid, id, chapter, hash_id) {
  if (nid) {
    var host = this.image_hosts_conf[nid]['host'];
    return "https://" + host + "/comic/" + id + "/" + chapter + "/" + hash_id;
  }
  return this.config.defalut_avatar;
}


function get_text_img(size, s, c = undefined) {
  let colors = [
    "rgb(239,150,26)", 'rgb(255,58,201)', "rgb(111,75,255)", "rgb(36,174,34)", "rgb(80,80,80)"
  ];
  let cvs = document.createElement("canvas");
  cvs.setAttribute('width', size[0]);
  cvs.setAttribute('height', size[1]);
  let ctx = cvs.getContext("2d");
  if (!c) {
    ctx.fillStyle = colors[Math.floor(Math.random() * (colors.length))];
  } else {
    ctx.fillStyle = c;
  }
  ctx.fillRect(0, 0, size[0], size[1]);
  ctx.fillStyle = 'rgb(255,255,255)';
  ctx.font = size[0] * 0.6 + "px Arial";
  ctx.textBaseline = "middle";
  ctx.textAlign = "center";
  ctx.fillText(s, size[0] / 2, size[1] / 2);

  return cvs.toDataURL('image/jpeg', 1);
}

Vue.prototype.get_text_img = get_text_img;
Vue.prototype.navigateToUrl = navigateToUrl;
Vue.prototype.getdate = getdate;
Vue.prototype.getDateDiff = getDateDiff;
Vue.prototype.getUrlVars = getUrlVars;
Vue.prototype.toThousands = toThousands;
Vue.prototype.showDate = showDate;
Vue.prototype.updateQueryStringParameter = updateQueryStringParameter;
Vue.prototype.generate_compic_url = generate_compic_url;
Vue.prototype.generate_cover_url = generate_cover_url;


Vue.prototype.get_vip_conf = function (vip_degree) {
  var vip_conf = this.$vip_degree_conf[vip_degree];
  if (!vip_conf) {
    return {
      "name": "未开通VIP",
      "discount": 1,
      'degree': "vip0"
    };
  }
  return vip_conf;
}


Vue.prototype.generate_avatar_url = generate_avatar_url;

Vue.prototype.$messageX = Vue.prototype.$message = function (message, params = {}) {

  console.log("call $message:", message);

  var {color, textColor, multiLine, icon, avatar, position, theme} = params;

  theme = !theme ? 'theme-color' : theme;

  position = !position ? "top-left" : position;
  color = !color ? theme : color;
  textColor = !textColor ? theme : textColor;

  const twoActions = true;

  this.$q.notify({
    color,
    textColor,
    message,
    position,
    avatar,
    multiLine,
    timeout: 5000
  })
};


Vue.prototype.$stringFormat = function stringFormat(formatted, args) {
  for (let i = 0; i < args.length; i++) {
    let regexp = new RegExp('\\{' + i + '\\}', 'gi')
    formatted = formatted.replace(regexp, args[i])
  }
  return formatted
};

Vue.mixin({
  data() {
    return {}
  },
  created: function () {

  }
})

//全局变量
Vue.prototype._g = {
  comic_datas: {},
  tabinfos: {},
  COMMON_ROW_COUNT: 6,
  PER_PAGE_COUNT: 30,
  buy_chapter: {
    gold: 20,
    all_buy_discount: 0.6
  }
}


Vue.config.devtools = true;
Vue.config.errorHandler = function (err, vm) {
  console.error(err)
};


window.addEventListener('resize', function () {
  console.log("addEventListener resize");
  Vue.prototype.update_row_count();
});